import { ProductKeysType } from '../../../../../model';
import { ProductKey } from '@atlassiansox/bxpkit-core';

export const getProductLabelFragment = (productKeys: ProductKeysType[]) => {
  const [{ product: productKey }] = productKeys;
  switch (productKey) {
    case ProductKey.JIRA_SERVICE_DESK:
    case ProductKey.JIRA_SERVICE_MANAGEMENT:
      return 'JSD';
    case ProductKey.JIRA_PRODUCT_DISCOVERY:
      return 'JiraProductDiscovery';
    case ProductKey.COMPASS:
      return 'Compass';
    case ProductKey.TEAM_CENTRAL:
      return 'Atlas';
    case ProductKey.FABRIC:
      return 'Fabric';
    case ProductKey.BEACON:
      return 'Beacon';
    case ProductKey.CONFLUENCE:
      return 'Confluence';
    default:
      return '';
  }
};
